/* globals axios */
import Vue from 'vue';
import Errors from '../classes/errors';

Vue.component('newsletter-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            captchaEl: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(event) {
            event.preventDefault();
            window.grecaptcha.ready(() => {
                const form = this.$el.querySelector('.form');
                this.captchaEl = form.recaptchaSitekey.value;
                if (this.captchaEl) {
                    window.grecaptcha.execute(this.captchaEl, { action: 'submit' }).then((token) => {
                        // Add your logic to submit to your backend server here.
                        // this.$el.querySelector('.form').submit();
                        form.gRecaptchaResponse.value = token;

                        if (this.submitting) {
                            return;
                        }

                        this.submitting = true;

                        axios.post('/', new FormData(form))
                        .then((response) => {
                            console.log('FORM: ', form);
                            this.submitting = false;
                            const result = response.data;

                            if (result.data.errors) {
                                this.errors.clear();
                                this.errors.record(result.data.errors);

                                return;
                            }

                            // Success
                            this.formCompleted = true;
                            this.errors.clear();

                            window.location = this.$refs.redirectUrl.value;
                            // this.scrollToTop();
                        })
                        .catch((error) => {
                            this.submitting = false;
                            console.log(error.response);
                        });
                    });
                }
            });
        },
    },
});
